<template>
    <div class="p-admin-conf-basic">
        <div class="card mb-3">
            <div class="card-header">医療機関情報設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <div v-if="conf.value_type === confValue.image" class="m-1">
                        <label
                            v-if="conf.is_display_name"
                            :for="`key-${conf.key}`"
                            class="vc-conf-name">
                            {{ conf.name }}：
                        </label>
                        <div id="c-upload" class="c-upload">
                            <div class="input-group c-upload__input mb-3">
                                <div class="u-fit">
                                    <b-form-file
                                        v-model="configurations[index].image.object"
                                        :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                        @change="onChangeBasicImage(configurations[index], index, $event)"
                                        placeholder="画像をアップロード"
                                        accept="image/jpeg, image/png, image/gif">
                                    </b-form-file>
                                    <div class="invalid-feedback d-block mt-1" v-if="errors[ `${index}.${helper.valueField(conf)}` ]">
                                        {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                                    </div>
                                </div>
                            </div>
                            <div v-if="conf.image.base64 !== null"
                                 class="c-upload__image">
                                <div class="c-upload__delete d-none"
                                     :class="{ 'd-flex justify-content-center align-items-center' : conf.image.base64 }">
                                    <label class="btn btn-sm btn-danger" @click="deleteImage(configurations[index])">画像を削除</label>
                                </div>
                                <img :src="conf.image.base64" class="img-thumbnail">
                            </div>
                            <div v-else-if="conf.value !== null && conf.value !== ''"
                                 class="c-upload__image">
                                <div class="c-upload__delete d-none"
                                     :class="{ 'd-flex justify-content-center align-items-center' : conf.value !== null && conf.value !== '' }">
                                    <label class="btn btn-sm btn-danger" @click="deleteImage(configurations[index])">画像を削除</label>
                                </div>
                                <img :src="conf.value" class="img-thumbnail">
                            </div>
                        </div>
                    </div>
                    <div v-else-if="conf.value_type === confValue.str" class="m-1">
                        <div class="form-group m-form__group">
                            <label
                                v-if="conf.is_display_name"
                                :for="`key-${conf.key}`"
                                class="vc-conf-name">
                                {{ conf.name }}：
                            </label>
                            <input
                                v-model="configurations[index].value"
                                :id="`key-${conf.key}`"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                type="text"
                                placeholder="">
                            <div
                                v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                                class="invalid-feedback d-block mt-1">
                                {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header">お知らせ設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <div v-if="conf.value_type === confValue.text" class="m-1">
                        <div class="form-group m-form__group">
                            <label
                                v-if="conf.is_display_name"
                                :for="`key-${conf.key}`"
                                class="vc-conf-name">
                                {{ conf.name }}：
                            </label>
                            <quill-editor
                                ref="myQuillEditor"
                                v-model="configurations[index].value"
                                :id="`key-${conf.key}`"
                                :options="editorOption">
                            </quill-editor>
                            <div
                                v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                                class="invalid-feedback d-block mt-1">
                                {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        quillEditor,
    },

    props: {
        conf: {
            type: Array,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            configurations: [],
            errors: {},
            inProgress: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
            editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline'],
                        ['link'],
                    ],
                },
                placeholder: 'ここに内容を入力してください',
            },
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            return this.helper.bindConfigurationsValue(this.configurations)
        },

        /**
         * 更新データ準備（画像）
         *
         * @return {object}
         */
        preparedImageConfigurations: function () {
            const formData = new FormData()
            this.configurations.map(conf => {
                if (conf.value_type === this.confValue.image) {
                    if (conf.image.flg_delete) {
                        formData.append( 'id[]', conf.id )
                        formData.append( 'flg_delete[]', '1' )
                    }
                    else if (conf.image.object) {
                        formData.append( 'id[]', conf.id )
                        formData.append( 'value_image[]', conf.image.object )
                    }
                }
            })
            return formData
        },
    },

    methods: {
        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.configurations.endpoint.base
            const options = {headers: {'Content-Type': 'multipart/form-data'}}

            await axios.post(endpoint, this.preparedConfigurations)
                .then(() => {
                    axios.post(`${endpoint}/image`, this.preparedImageConfigurations, options)
                        .then(() => {
                            this.errors = {}
                            bus.$emit('alert-success', '設定を更新しました。')
                        })
                        .catch(({response}) => {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        })
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },

        /**
         * 画像アップロード時
         *
         * @param {object} conf
         * @param {number} index
         * @param {object} $event
         */
        onChangeBasicImage: function(conf, index, $event) {
            const elem = $event.target
            this.errors = {}
            this.initImage(conf)

            if ( elem.files.length > 0 ) {
                if ( elem.files[0].size > 5242880 ) {
                    this.errors[`${index}.${this.helper.valueField(conf)}`] = ['画像のファイルサイズは5MB以内にしてください。']
                    return
                }

                conf.image.object = elem.files[0]
                conf.image.name = conf.image.object.name

                const fr = new FileReader()
                fr.onload = () => { conf.image.base64 = fr.result }
                fr.readAsDataURL( conf.image.object )
            }
        },

        /**
         * 画像削除の準備
         *
         * @param {object} conf
         */
        deleteImage: function(conf) {
            this.initImage(conf, true)
        },

        /**
         * 状態初期化
         *
         * @param {object} conf
         * @param {boolean} flgDelete
         */
        initImage: function(conf, flgDelete = false) {
            conf.value = null
            conf.image = {
                name: null,
                object: null,
                base64: null,
                flg_delete: flgDelete,
            }
        },
    },

    watch: {
        conf: function (conf) {
            this.configurations = conf
        },
    }
}
</script>

<style scoped lang="scss">
.c-upload__image {
    max-width: 350px;
    margin: 0 auto;
}

.vc-conf-name {
    color: #5f5f5f;
    font-size: 13px;
    font-weight: bold;
}

.vc-input-int {
    max-width: 100px;
}
</style>
